import React from 'react'
import {Card, Col, Row} from 'antd'
import CustomTable from '../../elements/Table/CustomTable'
import DateTimeCell from '../../elements/Table/Cells/DateTimeCell'
import UpperCaseCell from '../../elements/Table/Cells/UpperCaseCell'
import StaffStatus from '../../elements/StaffStatus'
import {get} from 'lodash'

const columns = [
  {
    Header: 'Name',
    accessor: 'owner.fn',
  },
  {
    Header: 'Status',
    accessor: 'action.status',
    Cell: UpperCaseCell,
  },
  {
    Header: 'Action Time',
    accessor: 'date',
    Cell: DateTimeCell,
  },
  {
    Header: 'Login Time',
    accessor: 'in',
    Cell: DateTimeCell,
  },
  {
    Header: 'Logout Time',
    accessor: 'out',
    Cell: DateTimeCell,
  },
  {
    Header: 'Action',
    accessor: 'action.value',
    Cell: ({value, original}) => (
      <StaffStatus
        className={'ant-list-item-meta-title'}
        value={value}
        _key={get(original, 'action.status')}
      />
    ),
  },
  {
    Header: 'Device',
    accessor: 'device',
    hideable: true,
    hideDefault: true,
  },
  {
    Header: 'IP Address',
    accessor: 'ip',
    hideable: true,
    hideDefault: true,
  },
]

export default function Sessions(props) {
  const {list, fetch, fetching} = props
  return (
    <Row style={{marginTop: '10px'}}>
      <Col offset={2} span={20}>
        <Card title={<h1>Session</h1>} bordered={true}>
          <CustomTable
            defaultPageSize={20}
            isFilterable={true}
            columns={columns}
            data={list}
            fetching={fetching}
            fetch={fetch}
            rowKey={'_key'}
          />
        </Card>
      </Col>
    </Row>
  )
}
